import { createI18n } from 'vue-i18n'
import cs from './cs.json'

export type MessageSchema = typeof cs

export const i18n = createI18n<[MessageSchema], 'cs'>({
  legacy: false,
  locale: 'cs',
  fallbackLocale: 'cs',
  messages: { cs },
  // Čeština má tvary: 0 | 1 | 2 až 4 | 5 a více (klíče oddělené svislítkem).
  pluralRules: {
    cs: (choice) => {
      if (choice === 0) return 0
      if (choice === 1) return 1
      if (choice >= 2 && choice <= 4) return 2
      return 3
    },
  },
})
